export const UPSELLING_REGISTRATION_HERO_HEADING =
  'Complete your Upskilling Registration';

export const UPSELLING_REGISTRATION_HERO_DESCRIPTION =
  'Pay registration fee & kick-start your tech journey';

export const UPSELLING_REGISTRATION_HERO_BUTTON_TEXT = 'Register Now';

export const ENROLLMENT_FEE_QUOTATION_BANNER_TEXT =
  "You've successfully completed the previous step. Next step: pay the Enrollment Fee.";

export const BOOTCAMP_QUOTATION_BANNER_TEXT =
  "You've successfully completed the previous step. Next step: register now for Upskilling Bootcamp 2026.";

export const ENROLLMENT_PAYMENT_TO_UNIVERSITY_LABEL =
  'Enrollment Payment to University';

export const ENROLLMENT_FEE_STAGE_COMPLETE_THRESHOLD = 50;
